import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CNameConfiguration } from '@models/email/emailDomain';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AtlasToastService } from '@services/atlas-toast.service';
import { EmailCampaignDnsService } from '@services/email-campaign-dns.service';
import { ToastContainerDirective } from 'ngx-toastr';
import { map } from 'rxjs/operators';

@Component({
  selector: 'wsb-email-add-sender-modal',
  templateUrl: './email-add-sender-modal.component.html',
  styleUrls: ['./email-add-sender-modal.component.scss'],
  standalone: false
})
export class EmailAddSenderModalComponent implements OnInit, AfterViewInit {
  @ViewChild(ToastContainerDirective) modalToastContainer: ToastContainerDirective;
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  @Input() public title;
  @Input() public text;
  @Input() public labelCancelButton = 'common_cancel';
  @Input() public labelSaveButton = 'common_ok';

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancelEvent: EventEmitter<any> = new EventEmitter();

  listEmailDomain: CNameConfiguration[] = [];
  addEmailSenderForm: UntypedFormGroup;
  showFirstDomainItem;

  constructor(
    public activeModal: NgbActiveModal,
    private atlasToast: AtlasToastService,
    private emailDnsService: EmailCampaignDnsService,
    private formBuilder: UntypedFormBuilder,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.addEmailSenderForm = this.buildForm();
    this.emailDnsService
      .getListDomainCampaigns()
      .pipe(
        map(list => {
          return list.filter(l => l.valid === true);
        })
      )
      .subscribe(data => {
        this.listEmailDomain = data;
        this.initDropdown();
      });
  }

  ngAfterViewInit(): void {
    const text = this.text;
    this.atlasToast.info(text, '', -1, this.toastContainer);
  }

  private initDropdown() {
    if (this.listEmailDomain.length === 0) {
      const labelNoDomain = this.translateService.instant('mail_user_add_nodomains');
      this.addEmailSenderForm.get('domain').setValue(labelNoDomain);
    } else {
      this.addEmailSenderForm.get('domain').setValue(this.listEmailDomain[0].domain);
    }
  }

  private buildForm() {
    return this.formBuilder.group({
      sender: this.formBuilder.control('', []),
      domain: this.formBuilder.control('', [Validators.required])
    });
  }

  private get(value) {
    return this.addEmailSenderForm.get(value).value;
  }

  getFormValue() {
    return {
      sender: this.get('sender'),
      domain: this.get('domain')
    };
  }
}
